import { AbstractControl, ValidatorFn, Validators } from "@angular/forms";
import { Campo } from "../../../models/coleta";
import { INPUT_TYPES, PROPRIEDADES, REGEX_TEXTO_ALFABETICO } from "./constants";
import {
  maxAgeValidator, minAgeValidator
} from "./age.validator";
import { cpfValidator } from "./cpf.validator";
import {
  maxLengthValidator, maxValueValidator, minLengthValidator, minValueValidator
} from "./size.validator";
import { patternValidator } from "./pattern.validator";
import { head, isObject, values } from "lodash";
import { cnpjValidator } from "./cnpj.validator";
import { equalsPhonesValidator, equalsPhonesErrorKey } from "./equalsPhones.validator";

export class AppValidators {
  static isValidCpf(): ValidatorFn {
    return cpfValidator.execute();
  }

  static isValidAlpha(): ValidatorFn {
    return patternValidator.execute(REGEX_TEXTO_ALFABETICO);
  }

  static isValidCnpj(): ValidatorFn {
    return cnpjValidator.execute();
  }

  static minAge(value: any): ValidatorFn {
    return minAgeValidator.execute(value);
  }

  static maxAge(value: any): ValidatorFn {
    return maxAgeValidator.execute(value);
  }

  static minLength(value: any): ValidatorFn {
    return minLengthValidator.execute(value);
  }

  static maxLength(value: any): ValidatorFn {
    return maxLengthValidator.execute(value);
  }

  static minValue(value: any): ValidatorFn {
    return minValueValidator.execute(value);
  }

  static maxValue(value: any): ValidatorFn {
    return maxValueValidator.execute(value);
  }

  static pattern(value: any): ValidatorFn {
    return patternValidator.execute(value);
  }

  static equalsPhones(value: any): ValidatorFn {
    return equalsPhonesValidator.execute(value);
  }

  static errorMessageFormGroup(formGroup: AbstractControl | undefined | null): string {
    if (!formGroup || formGroup.valid) {
      return "";
    }

    if (formGroup.hasError(equalsPhonesErrorKey)) {
      return formGroup.getError(equalsPhonesErrorKey);
    }

    if (isObject(formGroup.errors)) {
      return head(values(formGroup.errors)) || "Campo inválido";
    }

    return "Campo inválido";
  }

  static errorMessage(formControl: AbstractControl | undefined | null): string {
    if (!formControl || formControl.valid) {
      return "";
    }

    const specialErrors: { [key: string]: string } = {
      required: "Campo obrigatório",
      matDatepickerParse: "Data inválida",
      matDatepickerMin: "Data menor que o mínimo permitido",
      matDatepickerMax: "Data maior que o máximo permitido",
      pattern: "Campo preenchido incorretamente",
    };

    for (const [errorKey, message] of Object.entries(specialErrors)) {
      if (formControl.hasError(errorKey)) {
        return message;
      }
    }

    if (isObject(formControl.errors)) {
      const errorValues = values(formControl.errors);
      const firstError = head(errorValues);
      
      if (typeof firstError === "string") {
        return firstError;
      }
      
      if (isObject(firstError)) {
        const errorObj = firstError as any;
        if (errorObj?.message && typeof errorObj.message === "string") {
          return errorObj.message;
        }
        if (errorObj?.actual) {
          return "Campo preenchido incorretamente";
        }
      }
    }

    return "Campo preenchido incorretamente";
  }

  static getValidations(campo: Campo): ValidatorFn[] {
    const validators: ValidatorFn[] = [];

    // if (campo.tipo === INPUT_TYPES.IMAGE) {
    //   validators.push(Validators.required);
    // }

    if (campo.tipo === INPUT_TYPES.ALPHA) {
      validators.push(AppValidators.isValidAlpha);
    }

    if (campo.codigo) {
      if (campo.codigo === "consulta.respostas.invalidas") {
        return validators;
      }

      if (campo.codigo.indexOf("cpf") > -1) {
        validators.push(AppValidators.isValidCpf());
      }
      if (campo.codigo.indexOf("cnpj") > -1) {
        validators.push(AppValidators.isValidCnpj());
      }

      campo.atributos?.forEach((item) => {
        switch (item.propriedade) {
          case PROPRIEDADES.OBRIGATORIEDADE:
            // @ts-ignore
            if (item.valor === "true" || item.valor === true) {
              validators.push(
                campo.tipo === INPUT_TYPES.BOOL
                  ? Validators.requiredTrue
                  : Validators.required
              );
            }
            break;
          case PROPRIEDADES.PERIODO_MINIMO:
            validators.push(this.minAge(item.valor));
            break;
          case PROPRIEDADES.PERIODO_MAXIMO:
            validators.push(this.maxAge(item.valor));
            break;
          case PROPRIEDADES.MINIMO:
            validators.push(this.minLength(item.valor));
            break;
          case PROPRIEDADES.MAXIMO:
            validators.push(this.maxLength(item.valor));
            break;
          case PROPRIEDADES.VALOR_MINIMO:
            validators.push(this.minValue(item.valor));
            break;
          case PROPRIEDADES.VALOR_MAXIMO:
            validators.push(this.maxValue(item.valor));
            break;
          case PROPRIEDADES.PADRAO:
            validators.push(this.pattern(item.valor));
            break;
        }
      });
    }

    return validators;
  }
}
